export enum SIDEBAR_STATE {
  CLOSED = "closed",
  RECENT_THREADS = "recent",
  FILTERS = "filters",
  DOCUMENTS = "documents",
}

export type SidebarPanel =
  | SIDEBAR_STATE.RECENT_THREADS
  | SIDEBAR_STATE.CLOSED
  | SIDEBAR_STATE.FILTERS
  | SIDEBAR_STATE.DOCUMENTS;
